<template>
  <div class="products">
    <div class="splitColumns withMobileMargins">
      <div class="column33">
        <div
          v-if="currentRepoId"
          class="section smallBottomMargin"
        >
          <div class="sectionTitle">
            Python Packages
          </div>
          <Search
            :init-value="searchString"
            placeholder="Showing popular packages - type to search"
            @searchChange="searchChange"
          />
        </div>
        <PackagesList :packages="allPackages" />
        <div v-if="!packageName && !gettingPackages && currentRepoId && allPackages.length === 0">
          <NoPackages
            :repo-name="headerTitle"
            :no-subscriptions-for-repo="noSubscriptionsForRepo"
            :search-string="searchString"
          />
        </div>
        <GetMoreButton
          v-if="showGetNext"
          label="List more packages"
          @getMore="getNext"
        />
        <GettingMore
          :show="gettingPackages"
          label="Getting packages"
        />
      </div>
      <div class="column67 packageContainer">
        <div
          class="section"
          data-automation="package-section"
        >
          <transition name="fade-in-out">
            <Package v-if="selectedPackage" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import router from '../../router'

import PackagesList from './PackagesList'
import Package from './Package'
import GettingMore from '../GettingMore'
import GetMoreButton from '../GetMoreButton'
import NoPackages from '../NoPackages'
import Search from '../Search'
import popularPythonPkgs from '../../constants/python-packages'

import { helpers } from '../../api/http-common'

const popularIncrement = 10

export default {
  name: 'Packages',
  components: {
    PackagesList,
    Package,
    GetMoreButton,
    GettingMore,
    NoPackages,
    Search,
  },
  data: function () {
    return {
      searchString: '',
      packageName: null,
      doveToSinglePackage: false,
      popularCount: popularIncrement,
    }
  },
  computed: {
    ...mapState({
      gotRepos: state => state.repos.gotRepos,
      currentRepoId: state => state.repos.currentRepoId,
      gettingPackages: state => state.packages.gettingPackages,
      noSubscriptionsForRepo: state => state.packages.noSubscriptionsForRepo,
      allPackages: state => state.packages.allPackages,
      packagesCount: state => state.packages.packagesCount,
      selectedPackage: state => state.packages.selectedPackage,
      headerTitle: state => state.appFrame.headerTitle,
      selectedOS: state => state.packages.selectedOS,
    }),
    showGetNext: function () {
      if (this.allPackages.length === 0) {
        return false
      }

      if (!this.gettingPackages && (this.packagesCount > this.allPackages.length)) {
        return true
      }

      if (!this.gettingPackages && !this.searchString && !this.packageName && this.popularCount < popularPythonPkgs.length) {
        return true
      }

      return false
    },
  },
  watch: {
    currentRepoId: function (value) {
      this.packageName = null
      this.searchString = ''
      this.getFirst()
    },
    packageName: function (value) {
      this.getFirst()
    },
    '$route' (to, from) {
      if (to.params && to.params.packageName) {
        this.doveToSinglePackage = true
        this.packageName = to.params.packageName
        this.searchString = to.params.packageName
      } else {
        this.packageName = null
        this.searchString = ''
      }
    },
  },
  created: function () {
    if (this.$route.params && this.$route.params.packageName) {
      this.packageName = this.$route.params.packageName
    }

    // On create, prepopulate the searchString to allow the user to easily clear the search
    if (this.packageName) {
      this.searchString = this.packageName
    }

    this.getFirst()
  },
  mounted: function () {
    this.setCurrentNav({ page: 'packages' })
  },
  methods: {
    ...mapActions([
      'clearSelectedPackage',
      'getFirstPackages',
      'getPackage',
      'getPackageVersions',
      'getNextPackages',
      'setCurrentNav',
    ]),
    getFirst: function () {
      if (this.currentRepoId) {
        // Reset the popular count on each call to getFirst()
        this.popularCount = popularIncrement
        this.clearSelectedPackage()

        // Only use the popular packages list if the packageName and searchString aren't set
        let packages
        if (!this.searchString && !this.packageName) {
          packages = popularPythonPkgs.slice(0, this.popularCount)
        }

        this.getFirstPackages({ repoId: this.currentRepoId, searchString: this.searchString, packageName: this.packageName, packages })
          .then(() => {
            if (this.selectedPackage) {
              this.getPackage({ repoId: this.currentRepoId, name: this.selectedPackage.name, id: this.selectedPackage.id })
              const basePath = helpers.basePath(window)
              helpers.pushURL(this.selectedPackage.name, `${basePath}client/#/repos/${this.currentRepoId}/packages/${this.selectedPackage.name}`)
            }
          })
      }
    },
    getNext: function (event) {
      let packages
      let searchString = this.searchString
      if (!searchString && !this.packageName) {
        packages = popularPythonPkgs.slice(this.popularCount, this.popularCount + popularIncrement)
      } else if (!searchString && this.packageName) {
        searchString = this.packageName
      }

      this.popularCount += popularIncrement

      this.getNextPackages({ repoId: this.currentRepoId, searchString: searchString, packages: packages })
    },
    searchChange: function (s) {
      if (this.searchString === s) {
        return
      }

      this.searchString = s
      // Ignore redundant navigation warning
      router.replace({ name: 'packages' }).catch(() => {})
      this.getFirst()
    },
  },
}

</script>
